export const calculateInvoiceExpenseAmount = function (invoiceDetails = {}) {
    const freight = invoiceDetails?.freight || 0;
    const load_unload = invoiceDetails?.load_unload || 0;
    const insurance = invoiceDetails?.insurance || 0;
    const other = invoiceDetails?.other || 0;
    const other_for_import = invoiceDetails?.other_for_import || 0;
    return Number((freight + load_unload + insurance + other + other_for_import)?.toFixed(2));
}